import Language from 'types/LanguageEnum';
import { getUrlParam } from 'utils/urlUtils';
import { JMDict } from 'components/Keyboard/Custom/Japanese/types';

const loadJmdict = async (): Promise<JMDict> => {
  const token = getUrlParam('token') ?? getUrlParam('OSToken');
  const baseUrl = process.env.ASSETS_URL;
  const url = `${baseUrl}/public/themes/default/dictionaries/ja-jp/jmdict-eng-common.json?t=${token}`;

  const existing = Dictionaries.get(Language.JA_JP);
  if (existing) {
    return existing;
  }

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch JMdict: ${res.statusText}`);
  }

  const jmDict: JMDict = await res.json();
  Dictionaries.set(Language.JA_JP, jmDict);

  return jmDict;
};

export const DICTIONARY_LOADERS: Partial<Record<Language, () => Promise<Dictionary>>> = {
  [Language.JA_JP]: loadJmdict,
};

type DictionaryMap = {
  [key in Language]: key extends Language.JA_JP ? JMDict : never;
};

type Dictionary = DictionaryMap[Language];

export class Dictionaries {
  private static cache: Partial<Record<Language, Dictionary>> = {};

  static get(language: Language): Dictionary | undefined {
    return this.cache[language];
  }

  static set(language: Language, dictionary: Dictionary): void {
    this.cache[language] = dictionary;
  }
}